<app-site-dashboard
  containerClass="p-4 md:p-6 lg:p-8 w-full mx-auto space-y-6"
  [showHeader]="true"
></app-site-dashboard>
